<template>
  <section class="merge-request-security-card">
    <b class="merge-request-security-card__title">{{ $t('message.security') }}</b>
    <div class="merge-request-security-card__content">
      <div class="item">
        <i
          class="gf-icon gf-icon-shield gf-fs-2"
          :class="{ '--error': vulnerabilitesNumbers.SAST }"
        ></i>
        <small>{{ sastVulnerabilitiesNumberText }}</small>
        <b>SAST</b>
      </div>
      <div class="item">
        <i
          class="gf-icon gf-icon-shield gf-fs-2"
          :class="{ '--error': vulnerabilitesNumbers.DAST }"
        ></i>
        <small>{{ dastVulnerabilitiesNumberText }}</small>
        <b>DAST</b>
      </div>
    </div>
  </section>
</template>

<script>
import SecurityMessages from '@shared/modules/security/security.messages';
import SecurityService from '@/shared-modules/modules/security/security.service';

export default {
  name: 'MergeRequestSecurityCard',
  data() {
    return {
      vulnerabilitesNumbers: {
        SAST: null,
        DAST: null
      }
    };
  },
  computed: {
    sastVulnerabilitiesNumberText() {
      return this.vulnerabilitesNumbers.SAST
        ? this.$t('hasVulenarabilities')
        : this.$t('noVulenarabilities');
    },
    dastVulnerabilitiesNumberText() {
      return this.vulnerabilitesNumbers.DAST
        ? this.$t('hasVulenarabilities')
        : this.$t('noVulenarabilities');
    }
  },
  mounted() {
    this.getVulnerabilitiesInfo('SAST');
    this.getVulnerabilitiesInfo('DAST');
  },
  methods: {
    getVulnerabilitiesInfo(tool) {
      SecurityService.getVulnerabilitiesByMerge(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id,
        {
          vulnerabilityTool: tool
        }
      ).then((res) => {
        this.vulnerabilitesNumbers[tool] = res?.vulnerabilityOccurrencePipelineModel?._embedded;
      });
    }
  },
  i18n: {
    messages: SecurityMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-request-security-card';

#{$this} {
  display: flex;
  flex-direction: column;
  gap: 6px;

  #{$this}__content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    @include theme.max-lg {
      display: grid;
      grid-template-columns: repeat(2, calc(50% - 2px));
    }

    @include theme.max-sm {
      display: flex;
    }

    & > .item {
      display: flex;
      gap: 4px;
      font-size: 12px;

      & > i {
        color: var(--success);

        &.--error {
          color: var(--danger) !important;
        }
      }
    }
  }
}
</style>
